// Store 타입 정의
import { create } from "zustand";

type StepStore = {
  step: number;
  setStep: (step: number) => void;
  increaseStep: () => void;
  decreaseStep: () => void;
  resetStep: () => void;
};

const joinStepStore = (set: any): StepStore => ({
  step: 0,

  setStep: (step) => set({ step }),

  increaseStep: () => set((state: StepStore) => ({ step: state.step + 1 })),

  decreaseStep: () => set((state: StepStore) => ({ step: state.step - 1 })),

  resetStep: () => set({ step: 0 }),
});

const useJoinStepStore = create(joinStepStore);

export default useJoinStepStore;
